module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/plan1-2-6ee9c3ea26b33e48110e894b057b14e5.webp";